import { TableCell, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import React, { useCallback } from 'react';

const EnhancedTableHead = ({ order = { by: null, isReverse: false }, columns, onSort }) => {
  const sort = useCallback(
    property => () => {
      onSort(property);
    },
    [onSort],
  );

  const direction = order.isReverse ? 'desc' : 'asc';
  return (
    <TableHead sx={theme => ({ borderBottom: `1px solid ${theme.palette.divider}` })}>
      <TableRow sx={{ height: 48 }}>
        {columns.map(header => (
          <TableCell
            sx={{
              border: 0,
              pt: 0,
              pb: 0,
              fontSize: 13,
              '&:first-of-type': {
                minWidth: 250,
              },
              ...(!header.xsVisible && {
                display: { xs: 'none', sm: 'table-cell' },
              }),
            }}
            key={header.key}
            sortDirection={order.by === header.key ? direction : false}
          >
            {header.notSortable ? (
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: 1.29,
                  color: 'secondary.main',
                }}
              >
                {header.label}
              </Typography>
            ) : (
              <TableSortLabel
                active={order.by === header.key}
                direction={direction}
                onClick={sort(header.key)}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: 1.29,
                    color: 'secondary.main',
                  }}
                >
                  {header.label}
                </Typography>
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export const columnsShape = arrayOf(
  shape({
    key: string.isRequired,
    disablePadding: bool,
    label: string.isRequired,
    xsVisible: bool,
    notSortable: bool,
  }),
);

EnhancedTableHead.propTypes = {
  order: shape({
    by: string.isRequired,
    isReverse: bool.isRequired,
  }),
  columns: columnsShape.isRequired,
  onSort: func.isRequired,
};

export default EnhancedTableHead;
